import React, { useEffect, useState } from "react";

import useButtonLoader from "hooks/useButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { toastMessage } from "utils/toastMessage";

import {
  addCategory,
  fetchCategoryDetail,
  imgUploadToCloud,
  updateCategoryDetail,
} from "services/category";

import imgUploadToCloudFun from "components/modals/imgUploadAndGetUrl";
import { ImagePreview } from "utils/imagePreviewURLConverter";

const EditCat = ({
  editCategoryModalState,
  catDataFetchApiCall,
  closeModel,
  catTab,
  categoryForEdit,
}) => {
  const [error, setError] = useState({});
  const [buttonLoader, setButtonLoader] = useButtonLoader("Add");

  // Image states
  const [imgInputState, setImageInputState] = useState("");
  const [imgPreviewState, setImgPreviewState] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState("");

  // Category states
  const [catNameState, setCatNameState] = useState("");
  const [typesToComponent, setTypesToComponent] = useState([]);

  // ---------------- Validation ----------------
  const validation = () => {
    let status = true;
    let errorObject = {};

    if (!catNameState.trim()) {
      errorObject["categoryName"] = "Category Name is not Set";
      status = false;
    }

    setError(errorObject);

    return status;
  };

  // ---------------- Close Modal ----------------
  const addBannerCloseModal = () => {
    setImageInputState("");
    setImgPreviewState(null);
    setSelectedFileName("");
    setTypesToComponent([]);
    setCatNameState("");
    setError({});
    closeModel();
  };

  // ---------------- Update Category ----------------
  const editCatHandler = async (e) => {
    e.preventDefault();

    if (validation()) {
      setButtonLoader(true);

      try {
        const dataToSend = {
          name: catNameState,
          description: catNameState,
          type: catTab,
        };

        if (imgInputState.length !== 0) {
          dataToSend.image = imgInputState;
        }

        dataToSend.isSummer = typesToComponent.includes("isSummer");
        dataToSend.isWinter = typesToComponent.includes("isWinter");
        dataToSend.isRainy = typesToComponent.includes("isRainy");

        const { data } = await updateCategoryDetail({
          catUpdatedData: dataToSend,
          id: categoryForEdit,
        });

        if (data?.status === 200 || data?.code === 200) {
          catDataFetchApiCall();
          toastMessage(data?.message, "success", "addCategory");
          addBannerCloseModal();
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  // ---------------- Upload Image ----------------
  const imgUploadFunctions = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // Show selected file name
    setSelectedFileName(file.name);

    if (!file.type.includes("image/")) {
      setError((prev) => ({
        ...prev,
        imgErrorOccur: "Please Choose Image file not others",
      }));
      return;
    }

    try {
      const data = await imgUploadToCloudFun(file);

      if (data?.status === 200) {
        setImgPreviewState(file);
        setImageInputState(data?.data[0]);
      }
    } catch (error) {
      console.log("error while uploading image", error);
    }
  };

  const imgUploadFunction = async (e) => {
  const file = e.target.files[0];

  if (!file) return;

  setSelectedFileName(file.name);

  if (!file.type.startsWith("image/")) {
    setError((prev) => ({
      ...prev,
      imgErrorOccur: "Please choose an image file only.",
    }));
    return;
  }

  setError((prev) => ({
    ...prev,
    imgErrorOccur: "",
  }));

  try {
    const data = await imgUploadToCloudFun(file);

    if (data?.status === 200) {
      setImgPreviewState(file);
      setImageInputState(data.data[0]);
    }
  } catch (err) {
    console.log(err);
  }
};

  // ---------------- Fetch Old Category ----------------
  const fetchOldCatData = async () => {
    try {
      const {
        data: { data, status, code },
      } = await fetchCategoryDetail(categoryForEdit);

      if (status === 200 || code === 200) {
        setImgPreviewState(data?.image);
        setCatNameState(data?.name);

        // Display existing image name
        if (data?.image) {
          const fileName = data.image.split("/").pop();
          setSelectedFileName(fileName);
        }

        const arr = [];

        if (data?.isSummer) arr.push("isSummer");
        if (data?.isWinter) arr.push("isWinter");
        if (data?.isRainy) arr.push("isRainy");

        setTypesToComponent(arr);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (editCategoryModalState) {
      fetchOldCatData();
    }
  }, [editCategoryModalState]);

  return (
    <CustomModal
      className={"add_model"}
      show={editCategoryModalState}
      handleClose={addBannerCloseModal}
    >
      <h3>Edit Category</h3>

      {/* Category Name */}
      <div className="form_field">
        <label htmlFor="cat-name" className="label">
          Category Name
        </label>

        <input
          className="input form-control"
          type="text"
          id="cat-name"
          value={catNameState}
          maxLength={50}
          onChange={(e) => setCatNameState(e.target.value)}
        />

        {error.categoryName && (
          <p className="error">{error.categoryName}</p>
        )}
      </div>

      {/* Upload Image */}
     {/* Upload Image */}
<div className="form_field">
  <label className="label">
    Change Category Logo (237px × 378px)
  </label>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      border: "1px solid #d9d9d9",
      borderRadius: "6px",
      height: "42px",
      overflow: "hidden",
      width: "100%",
    }}
  >
    <label
      htmlFor="categoryImage"
      style={{
        padding: "10px 18px",
        background: "#f3f3f3",
        borderRight: "1px solid #d9d9d9",
        cursor: "pointer",
        margin: 0,
        whiteSpace: "nowrap",
      }}
    >
      Choose File
    </label>

    <span
      style={{
        padding: "0 12px",
        color: "#666",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        flex: 1,
      }}
    >
      {selectedFileName || "No file chosen"}
    </span>

    <input
      id="categoryImage"
      type="file"
      accept="image/*"
      style={{ display: "none" }}
      onChange={imgUploadFunction}
    />
  </div>

  {error.imgErrorOccur && (
    <p className="red-color">{error.imgErrorOccur}</p>
  )}

  <div className="image_preview" style={{ marginTop: "15px" }}>
    <ImagePreview file={imgPreviewState} />
  </div>
</div>

      {/* Category Type */}
      <div className="form_field">
        <label className="label">Category Type</label>

        <CatTypeComponent
          typesToComponent={typesToComponent}
          setTypesToComponent={setTypesToComponent}
        />
      </div>

      <div className="button_wrap">
        <button
          type="button"
          className="button light"
          onClick={addBannerCloseModal}
        >
          Cancel
        </button>

        <button
          type="button"
          ref={buttonLoader}
          className="button"
          onClick={editCatHandler}
        >
          Submit
        </button>
      </div>
    </CustomModal>
  );
};

export default EditCat;

// ===================== Category Type Component =====================

const CatTypeComponent = ({
  typesToComponent,
  setTypesToComponent,
}) => {
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    if (checked) {
      setTypesToComponent((prev) => [...prev, value]);
    } else {
      setTypesToComponent((prev) =>
        prev.filter((item) => item !== value)
      );
    }
  };

  return (
    <div className="select_list">
      <label>
        <input
          type="checkbox"
          value="isSummer"
          checked={typesToComponent.includes("isSummer")}
          onChange={handleCheckboxChange}
        />
        Shop By Summary Category
      </label>

      <label>
        <input
          type="checkbox"
          value="isWinter"
          checked={typesToComponent.includes("isWinter")}
          onChange={handleCheckboxChange}
        />
        Shop By Winter Category
      </label>

      <label>
        <input
          type="checkbox"
          value="isRainy"
          checked={typesToComponent.includes("isRainy")}
          onChange={handleCheckboxChange}
        />
        Shop By Rainy Category
      </label>
    </div>
  );
};